import React, { useEffect } from 'react'
import ContactForm from '../Components/ContactForm'
import Aboutvisitus from '../Components/Aboutvisitus'
import Aos from 'aos';
import 'aos/dist/aos.css';
export default function ContactUs() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [])
  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);

  return (
    <div >
      <title>
        Contact MagnAid Hospitals for Inquiries and Appointments
      </title>
      <meta name="description" content="Contact MagnAid Hospitals for inquiries and appointments. Call our hospital for quick assistance or use our phone number for expert care and services today." />
      <ContactForm />
      <Aboutvisitus />
     
      <div className='bg-[#c4d6d6] h-[1px]'></div>
    </div>
  )
}
